<template>
  <el-dialog title="新增提供商" 
            :visible.sync="dialogVisible" 
            width="600px" 
            @close="resetForm"    
            :close-on-click-modal="false">
    <el-form
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="140px"
      size="small"
    >
      <!-- 各个表单项 -->
      <el-form-item label="提供商：" prop="provider">
        <el-input v-model="createForm.provider" placeholder="请输入提供商名称（ 例如：北京 ）"></el-input>
      </el-form-item>
      <el-form-item label="资源所在地：" prop="location">
        <el-input v-model="createForm.location" placeholder="请输入资源所在地"></el-input>
      </el-form-item>
      <el-form-item label="GPU型号：" prop="gpu_model">
        <el-input v-model="createForm.gpu_model" placeholder="请输入GPU型号"></el-input>
      </el-form-item>
      <el-form-item label="规模：" prop="scale">
        <el-input type="textarea" :rows="3" v-model="createForm.scale" placeholder="请输入规模"></el-input>
      </el-form-item>
      <el-form-item label="电话：" prop="provider_tel">
        <el-input v-model="createForm.provider_tel" placeholder="请输入联系电话"></el-input>
      </el-form-item>
       <el-form-item label="联系人：" prop="contacts">
        <el-input v-model="createForm.contacts" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="租赁规模：" prop="lease_scale">
        <el-select v-model="createForm.lease_scale" placeholder="请选择租赁规模" style="width: 100%;">
          <el-option label="任意" :value="0"></el-option>
          <el-option label="整租" :value="1"></el-option>
          <el-option label="散租" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="租赁形式：" prop="lease_type">
        <el-select v-model="createForm.lease_type" placeholder="请选择租赁形式" style="width: 100%;">
          <el-option label="任意" :value="0"></el-option>
          <el-option label="开口" :value="1"></el-option>
          <el-option label="闭口" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择状态" style="width: 100%;">
          <el-option label="有效" :value="0"></el-option>
          <el-option label="关闭" :value="1"></el-option>
          <el-option label="待定" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可用期开始时间：" prop="start_time">
        <el-date-picker v-model="createForm.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="可用期结束时间：" prop="end_time">
        <el-date-picker v-model="createForm.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="说明：" prop="remark">
        <el-input type="textarea" :rows="3" v-model="createForm.remark" placeholder="请输入说明（可选）"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateProvider',
  data() {
    return {
      dialogVisible: false,
      createForm: {
        provider: '',
        location: '',
        contacts: '',
        provider_tel: '',
        gpu_model: '',
        scale: '',
        start_time: '',
        end_time: '',
        lease_scale: 0,
        lease_type: 0,
        status: 0,
        remark: ''
      },
      rules: {
        provider: [{ required: true, message: '请输入提供商', trigger: 'blur' }],
        location: [{ required: true, message: '请输入地理位置', trigger: 'blur' }],
        scale: [{ required: true, message: '请输入规模', trigger: 'blur' }],
        gpu_model: [{ required: true, message: '请输入GPU型号', trigger: 'blur' }],
        provider_tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        start_time: [
          {
            validator: (rule, value, callback) => {
              // 非必填，留空也通过
              callback();
            },
            trigger: 'change'
          }
        ],

        // 结束时间：非必填，但若填写则必须 > 开始时间
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.createForm.start_time;
              const endTime = value;

              // 如果两个时间都没填 → 通过
              if (!startTime && !endTime) {
                return callback();
              }

              // 如果只填了结束时间 → 通过（非必填）
              if (!startTime && endTime) {
                return callback();
              }

              // 如果只填了开始时间 → 通过
              if (startTime && !endTime) {
                return callback();
              }

              // 两个都填了，才做比较
              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('可用期结束时间必须大于开始时间'));
              } else {
                callback(); // 校验通过
              }
            },
            trigger: 'change'
          }
        ],
      }
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createForm.clearValidate();
      });
    },
    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },
    submitForm() {
      this.$refs.createForm.validate(valid => {
        if (!valid) return;
        const postData = { ...this.createForm };
        // 发送请求
        this.$axios.post('/api-30216/api/regions', postData)
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success(responseData.message || '新增成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(responseData.message || '新增失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err.response && err.response.data) {
              errorMessage = err.response.data.message || errorMessage;
            } else if (err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('请求错误详情:', err);
          });
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>